import { CardRoot } from "./CardRoot";

export const CardComponent = {
  Root: CardRoot,
};
